export default __webpack_public_path__ + "img/BrandAvatar.4f8beba8.webp";